<template>
    <div class="order_action">
        <b-overlay :is_show="is_load">
            <div class="actions">
                <button type="button" class="btn btn-lg  waves-effect waves-themed w-100 mb-3" :class="get_butt_class(state.action)"
                        v-for="state in o_states" v-on:click="set_state(state.action)">
                    <span class="fal fa-check mr-1"></span>
                    {{__t(state.human)}}
                </button>

                <div class="adm_action mt-5">
                    <button type="button" class="btn btn-lg  waves-effect waves-themed w-100 mb-3 btn-danger" v-on:click="set_state('hide_active')" >
                        {{  __t('FORCE_MOVE_FINISH_STATE') }}
                    </button>
                </div>


            </div>
        </b-overlay>
    </div>
</template>

<script>
export default {
    name: "order_action",
    props : {
        order : {
            type : Object
        }
    },
    data () {
        return {
            is_load : false,
            o_states : [],
        }
    },

    created() {
        this.load_states();
    },
    methods : {

        get_butt_class(action) {

            if(action == 'reject') {
                return "btn-danger"
            }
            if(action == 'accept') {
                return "btn-success"
            }


            return "btn-primary";
        },

        async load_states() {
            this.o_states = [];
            this.is_load = true;
            api.get('/internal/v1/catalog/orders/' + parseInt(this.order.id) + "/states").then(({data}) => {
                this.is_load = false;
                this.o_states = data.data;

            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
        },
        set_state(state) {

            this.is_load = true;
            this.get_api_endpoint.patch('/order/' + parseInt(this.order.id) + "/status/" + state).then(({data}) => {
                this.is_load = false;
                EventBus.$emit("reload_order_inside");
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit("reload_order_inside");
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });

        }

    },
    computed : {

        get_api_endpoint() {
            if(this.is_delivery) {
                return delivery_api;
            }
            return agr_api;
        },

        is_delivery() {
            if(this.order.hasOwnProperty("is_delivery")) {
                return this.order.is_delivery;
            }

            return false;
        },
    },
}
</script>

<style scoped>

</style>
